// import React from "react";
// import { useNavigate } from "react-router-dom";
// import BackIcon from "../assets/icons/thinkIcons/backIcon.png";

// export default function SpecificTransaction() {
//   const navigate = useNavigate();

//   return (
//     <div className="sm:p-4 md:p-8 lg:p-10">
//       {/* Back Button */}
//       <div className="flex justify-end">
//         <button
//           onClick={() => navigate("/user/dashboard/fraud_detection")}
//           className="flex items-center gap-2 border border-black px-3 py-2 rounded-full cursor-pointer"
//         >
//           <img src={BackIcon} />
//           <span className="text-xs">Back</span>
//         </button>
//       </div>

//       <h2 className="textcolor font-semibold mt-4 mb-8">
//         | Check for Specific Transactions
//       </h2>

//       <div className="border-1 border-blue-custom rounded-md p-6 pt-8">
//         <div className="grid grid-cols-3 gap-4">
//           <div>
//             <label className="block mb-2 text-md font-semibold">
//               Transaction ID
//             </label>
//             <input
//               type="text"
//               placeholder="0000 0000 0000 0000"
//               className="border-1 border-blue-custom rounded-xl w-[424px] h-[62px] px-3 py-2"
//             />
//           </div>
//           <div>
//             <label className="block mb-2 text-md font-semibold">Amount</label>
//             <input
//               type="number"
//               placeholder="00.00"
//               className="border-1 border-blue-custom rounded-xl w-[424px] h-[62px] px-3 py-2"
//             />
//           </div>
//           <div>
//             <label className="block mb-2 text-md font-semibold">
//               Transaction Type
//             </label>
//             <select className="border-1 border-blue-custom rounded-xl w-[424px] h-[62px] px-3 py-2">
//               <option>Transfer</option>
//               <option>Withdrawal</option>
//               <option>Purchase</option>
//             </select>
//           </div>
//           <div>
//             <label className="block mb-2 text-md font-semibold">
//               Customer Id
//             </label>
//             <input
//               type="text"
//               placeholder="ABS2345"
//               className="border-1 border-blue-custom rounded-xl w-[424px] h-[62px] px-3 py-2"
//             />
//           </div>
//           <div className="flex-col">
//             <label className="block mb-2 text-md font-semibold">Duration</label>
//             <div className="flex gap-2">
//               <div>
//                 <input
//                   type="text"
//                   placeholder="MM-DD-YYYY"
//                   className="border-1 border-blue-custom rounded-xl w-[208px] h-[62px] px-3 py-2"
//                 />
//               </div>
//               <div>
//                 <input
//                   type="text"
//                   placeholder="00:00"
//                   className="border-1 border-blue-custom rounded-xl w-[208px] h-[62px] px-3 py-2"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="flex justify-center mt-14 mb-8">
//           <button className="bgbtn1 textwhite px-6 py-2 rounded-lg shadow font-semibold">
//             Check Transaction
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BackIcon from "../assets/icons/thinkIcons/backIcon.png";

export default function SpecificTransaction() {
  const navigate = useNavigate();

  const [transactionId, setTransactionId] = useState("");
  const [amount, setAmount] = useState("");
  const [transactionType, setTransactionType] = useState("Transfer");
  const [customerId, setCustomerId] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCheckTransaction = async () => {
    if (
      !transactionId ||
      !amount ||
      !transactionType ||
      !customerId ||
      !date ||
      !time
    ) {
      alert("Please fill all fields");
      return;
    }

    const transaction_time = `${date} ${time}`;
    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/fraud/check-specific-transaction`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            transaction_id: parseInt(transactionId),
            amount: parseFloat(amount),
            transaction_type: transactionType,
            customer_id: parseInt(customerId),
            transaction_time,
          }),
        }
      );

      const data = await res.json();
      setResult(data);
    } catch (err) {
      console.error(err);
      alert("Error checking transaction");
    }
    setLoading(false);
  };

  return (
    <div className="p-4 sm:p-6 lg:p-10">
      {/* Back Button */}
      <div className="flex justify-end">
        <button
          onClick={() => navigate("/user/dashboard/fraud_detection")}
          className="flex items-center gap-2 border border-black px-3 py-2 rounded-full"
        >
          <img src={BackIcon} alt="Back" />
          <span className="text-xs sm:text-sm">Back</span>
        </button>
      </div>

      <h2 className="textcolor font-semibold mt-4 mb-8 text-base sm:text-lg lg:text-3xl">
        | Check for Specific Transactions
      </h2>

      <div className="border-1 border-blue-custom rounded-md p-4 sm:p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Transaction ID */}
          <div>
            <label className="block mb-2 text-md font-semibold">
              Transaction ID
            </label>
            <input
              type="text"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              placeholder="0000 0000 0000 0000"
              className="border-1 border-blue-custom rounded-xl w-full h-[50px] sm:h-[56px] lg:h-[62px] px-3"
            />
          </div>

          {/* Amount */}
          <div>
            <label className="block mb-2 text-md font-semibold">Amount</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="00.00"
              className="border-1 border-blue-custom rounded-xl w-full h-[50px] sm:h-[56px] lg:h-[62px] px-3"
            />
          </div>

          {/* Transaction Type */}
          <div>
            <label className="block mb-2 text-md font-semibold">
              Transaction Type
            </label>
            <select
              value={transactionType}
              onChange={(e) => setTransactionType(e.target.value)}
              className="border-1 border-blue-custom rounded-xl w-full h-[50px] sm:h-[56px] lg:h-[62px] px-3"
            >
              <option>Transfer</option>
              <option>Withdrawal</option>
              <option>Purchase</option>
            </select>
          </div>

          {/* Customer ID */}
          <div>
            <label className="block mb-2 text-md font-semibold">
              Customer Id
            </label>
            <input
              type="text"
              value={customerId}
              onChange={(e) => setCustomerId(e.target.value)}
              placeholder="ABS2345"
              className="border-1 border-blue-custom rounded-xl w-full h-[50px] sm:h-[56px] lg:h-[62px] px-3"
            />
          </div>

          {/* Duration */}
          <div>
            <label className="block mb-2 text-md font-semibold">Duration</label>
            <div className="flex flex-col sm:flex-row gap-2">
              <input
                type="text"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                placeholder="MM-DD-YYYY"
                className="border-1 border-blue-custom rounded-xl w-full sm:w-1/2 h-[50px] sm:h-[56px] lg:h-[62px] px-3"
              />
              <input
                type="text"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                placeholder="HH:MM"
                className="border-1 border-blue-custom rounded-xl w-full sm:w-1/2 h-[50px] sm:h-[56px] lg:h-[62px] px-3"
              />
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="flex justify-center mt-10 mb-8">
          <button
            onClick={handleCheckTransaction}
            className="bgbtn1 textwhite px-6 py-2 sm:px-8 sm:py-3 rounded-lg shadow font-semibold text-sm sm:text-base"
            disabled={loading}
          >
            {loading ? "Checking..." : "Check Transaction"}
          </button>
        </div>

        {/* Result */}
        {result && (
          <div className="mt-6 p-4 border rounded-lg bg-gray-50 text-sm sm:text-base">
            <p className="text-lg font-semibold">
              Fraud Status: {result["Fraud Status"]}
            </p>
            <p className="text-md">
              Fraud Probability: {result["Fraud Probability"]}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

// return (
//   <div className="p-4 sm:p-6 lg:p-10">
//     {/* Back Button */}
//     <div className="flex justify-end">
//       <button
//         onClick={() => navigate("/user/dashboard/fraud_detection")}
//         className="flex items-center gap-2 border border-black px-3 py-2 rounded-full"
//       >
//         <img src={BackIcon} alt="Back"/>
//         <span className="text-xs">Back</span>
//       </button>
//     </div>

// <h2 className="textcolor font-semibold mt-4 mb-8">
//   | Check for Specific Transactions
// </h2>

//     <div className="border-1 border-blue-custom rounded-md p-4 sm:p-6">
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//         {/* Transaction ID */}
//         <div>
//           <label className="block mb-2 text-md font-semibold">Transaction ID</label>
//           <input
//             type="text"
//             value={transactionId}
//             onChange={(e) => setTransactionId(e.target.value)}
//             placeholder="0000 0000 0000 0000"
//             className="border-1 border-blue-custom rounded-xl w-full h-[56px] sm:h-[62px] px-3"
//           />
//         </div>

//         {/* Amount */}
//         <div>
//           <label className="block mb-2 text-md font-semibold">Amount</label>
//           <input
//             type="number"
//             value={amount}
//             onChange={(e) => setAmount(e.target.value)}
//             placeholder="00.00"
//             className="border-1 border-blue-custom rounded-xl w-full h-[56px] sm:h-[62px] px-3"
//           />
//         </div>

//         {/* Transaction Type */}
//         <div>
//           <label className="block mb-2 text-md font-semibold">Transaction Type</label>
//           <select
//             value={transactionType}
//             onChange={(e) => setTransactionType(e.target.value)}
//             className="border-1 border-blue-custom rounded-xl w-full h-[56px] sm:h-[62px] px-3"
//           >
//             <option>Transfer</option>
//             <option>Withdrawal</option>
//             <option>Purchase</option>
//           </select>
//         </div>

//         {/* Customer ID */}
//         <div>
//           <label className="block mb-2 text-md font-semibold">Customer Id</label>
//           <input
//             type="text"
//             value={customerId}
//             onChange={(e) => setCustomerId(e.target.value)}
//             placeholder="ABS2345"
//             className="border-1 border-blue-custom rounded-xl w-full h-[56px] sm:h-[62px] px-3"
//           />
//         </div>

//         {/* Duration */}
//         <div>
//           <label className="block mb-2 text-md font-semibold">Duration</label>
//           <div className="flex flex-col sm:flex-row gap-2">
//             <input
//               type="text"
//               value={date}
//               onChange={(e) => setDate(e.target.value)}
//               placeholder="MM-DD-YYYY"
//               className="border-1 border-blue-custom rounded-xl w-full sm:w-1/2 h-[56px] sm:h-[62px] px-3"
//             />
//             <input
//               type="text"
//               value={time}
//               onChange={(e) => setTime(e.target.value)}
//               placeholder="HH:MM"
//               className="border-1 border-blue-custom rounded-xl w-full sm:w-1/2 h-[56px] sm:h-[62px] px-3"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Submit Button */}
//       <div className="flex justify-center mt-10 mb-8">
//         <button
//           onClick={handleCheckTransaction}
//           className="bgbtn1 textwhite px-6 py-2 rounded-lg shadow font-semibold"
//           disabled={loading}
//         >
//           {loading ? "Checking..." : "Check Transaction"}
//         </button>
//       </div>

//       {/* Result */}
//       {result && (
//         <div className="mt-6 p-4 border rounded-lg bg-gray-50">
//           <p className="text-lg font-semibold">
//             Fraud Status: {result["Fraud Status"]}
//           </p>
//           <p className="text-md">
//             Fraud Probability: {result["Fraud Probability"]}
//           </p>
//         </div>
//       )}
//     </div>
//   </div>
// );
